import { Box, HStack, Typography } from '@tq/ui-components';
import { useTranslation } from 'react-i18next';
import { GetCaseDetailsResponse } from 'types';

export const EastingNorthing: React.FC<{ caseDetails?: GetCaseDetailsResponse }> = ({
  caseDetails,
}) => {
  const { t } = useTranslation('case_details_map');

  return (
    <HStack
      justifyContent={{ base: 'center', lg: 'unset' }}
      alignItems={{ base: 'center', lg: 'unset' }}
      mt={0}
      mb={{ base: 0, lg: 8 }}
    >
      <Box mr={12}>
        <strong>{t('easting', 'Easting')}:</strong>
        <Typography display='inline' ml={1}>
          {caseDetails?.application?.easting}
        </Typography>
      </Box>
      <Box>
        <strong>{t('northing', 'Northing')}:</strong>
        <Typography display='inline' ml={1}>
          {caseDetails?.application?.northing}
        </Typography>
      </Box>
    </HStack>
  );
};
